import logo from "../logos/sidekick.svg";
import { colors } from "../style";

function SplashScreen() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: colors.pageBackground,
      }}
    >
      <img
        src={logo}
        alt="Logo"
        style={{ width: "50vw", maxWidth: "160px", minWidth: "96px" }}
      />
    </div>
  );
}

export default SplashScreen;
